import React from "react";

export default function SmallSpinner() {
  return <span className="SmallSpinner"/>;
}

SmallSpinner.description = `
  A small, option-less configuration spinner.
`;



// WEBPACK FOOTER //
// src/components/SmallSpinner.js